import React, { Component } from 'react';
// react component used to create charts
// import ReactDOM from 'react-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import Spinner from 'react-spinkit';
import Button from 'elements/CustomButton/CustomButton.jsx';
import PaypalButton from 'elements/Paypal/PaypalButton.jsx';
// import { DataAPI } from 'services/DataService.jsx';

import Log from 'services/Log.jsx'


// import paypal from 'paypal-checkout';

// const PaypalButton = paypal.Button.driver('react', {React, ReactDOM});

class Step3 extends Component{
    constructor(props){
        super(props);
        this.state = {
            alert: null,
            loading: true
        }
    }
    isValidated(){
        return true;
    }
    successAlert(){
        this.setState({
            alert: (
                <SweetAlert
                    success
                    style={{display: "block",marginTop: "-100px"}}
                    title="Good job!"
                    onConfirm={() => this.setState({ alert: null })}
                    onCancel={() => this.setState({ alert: null })}
                    confirmBtnBsStyle="info"
                >
                    You clicked the finish button!
                </SweetAlert>
            )
        });
    }
    completeSetup(data, actions) {
      this.props.submitProject(data.paymentToken);
      Log.debug("yay2");
    }
    getDataResolutionName(id) {
      switch (id) {
        case "0":
          return "1 millisecond"
        case "1":
          return "1 second"
        case "2":
          return "1 minute"
        case "3":
          return "10 minutes"
        default:
          return "N/A"
      }
    }
    getDataRetentionName(id) {
      switch (id) {
        case "0":
          return "7 days"
        case "1":
          return "1 year"
        case "2":
          return "2 years"
        default:
          return "N/A"
      }
    }
    render(){
      const client = {
  			sandbox:    'AdQeS2mhsS_LXs1kq1cqK0ZU5PvduA3FmlE79aqtmNySoC9d79MK4CktHD3xqwm3LwZuQUQ4LSOshCk2',
  			production: 'AbXvUnHyTPektz3Evnhgy2l5Soj4J1BqYDKSn386FA2uSqyeep9P3nQQZIBygfDRpNYIJWTUK7i4i3dI',
  		};
      Log.debug(this.props.uid);
      Log.debug(this.props.projectDetails);
        return (
            <div className="wizard-step">
                <h2>{this.props.projectDetails.title}</h2>
                <br/>
                <p>You will not be billed untill you complete your project setup.</p>
                <p>You have to authorize your subscription before you can complete your setup.</p>
                <h3>Plan Details</h3>
                <p>Description: {this.props.projectDetails.description}</p>
                <p>Payment period: {this.props.projectDetails.anual ? "Annual" : "Monthly"}</p>
                <p>Amount: {this.props.projectDetails.price}$</p>
                <h3>Quotas</h3>
                <p>Datapoints included: {this.props.projectDetails.datapoints}/month</p>
                <p>Clients included: unmetered</p>
                <p>Metrics included: unmetered</p>
                <p>Data Tagging: {this.props.projectDetails.tagging ? "Supproted" : "Not supported"}</p>
                <p>Data Resolution: {this.getDataResolutionName(this.props.projectDetails.resolution)}</p>
                <p>Data Retention: {this.getDataRetentionName(this.props.projectDetails.retention)}</p>
                <br/>
                {this.state.alert}
                <div className={"wizard-finish-button " + ((this.props.isCreating) ? "wizard-disabled" : "")}>
                    <Button bsStyle="info" fill wd disabled={this.state.isCreating} onClick={this.props.openCheckout} pullRight><Spinner fadeIn='none' name='double-bounce' /> Create</Button>
                </div>
            </div>
        );
    }
}

export default Step3;



// WEBPACK FOOTER //
// ./src/views/Forms/Wizard/Step3.jsx